import { render } from "./TotalTeacher.vue?vue&type=template&id=4b3b1285"
import script from "./TotalTeacher.vue?vue&type=script&lang=js"
export * from "./TotalTeacher.vue?vue&type=script&lang=js"

import "./TotalTeacher.vue?vue&type=style&index=0&id=4b3b1285&lang=scss"

import exportComponent from "/var/www/html/amatra-frontend-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__